import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { ChatContent, ChatTopic, Knowledge } from "@/types/writing";

import { addChat, deleteChat, updateChat, getChats, sendMsg, getChatMsgs } from "@/services/api/thunks/chat";

export interface ChatState {
  currentTopic: ChatTopic;
  currentChatList: ChatContent[];
  chatRoomList: ChatTopic[];
  knowledgeBaseTopicList: Knowledge[];
  currentKnowledgeTopic: Knowledge;
}

const initialState: ChatState = {
  currentTopic: {} as ChatTopic,
  currentChatList: [],
  chatRoomList: [],
  knowledgeBaseTopicList:[{
    id: "1",
    user_id:"",
    title: "公开测试1",
    isPublic: "公开",
    intro: "",
    docOverlapNum: 0,
    docRecallMaxNum: 0,
    docRecallMinNum: 0,
    resRandomness: 0
  },{
    id: "2",
    user_id:"",
    title: "私有测试2",
    isPublic: "私有",
    intro: "",
    docOverlapNum: 0,
    docRecallMaxNum: 0,
    docRecallMinNum: 0,
    resRandomness: 0
  }],
  currentKnowledgeTopic: {} as Knowledge,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setCurrentTopic: (state, action: PayloadAction<ChatTopic>) => {
      state.currentTopic = action.payload;
    },
    setCurrentChatList: (state, action: PayloadAction<ChatContent[]>) => {
      state.currentChatList = action.payload;
    },
    setChat: (state, action: PayloadAction<ChatContent>) => {
      state.currentChatList.push(action.payload);
    },

    updateChatMsg: (state, action: PayloadAction<ChatContent>) => {
      const { id } = action.payload;
      const index = state.currentChatList.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.currentChatList[index] = action.payload;
      }
    },
    deleteChatMsg: (state, action: PayloadAction<ChatContent>) => {
      const { id } = action.payload;
      state.currentChatList = state.currentChatList.filter((item) => item.id !== id);
    },

    setCurrentKnowledgeTopic: (state, action: PayloadAction<Knowledge>) => {
      state. currentKnowledgeTopic = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(addChat.fulfilled, (state, action) => {
      state.chatRoomList.splice(0, 0, action.payload);
      state.currentTopic = action.payload;
    });
    builder.addCase(deleteChat.fulfilled, (state, action) => {
      const chatId = action.payload;
      state.chatRoomList = state.chatRoomList.filter((item) => item.id !== chatId);
      if (state.chatRoomList) {
        state.currentTopic = state.chatRoomList[0];
      }

      state.currentChatList = [];
    });
    builder.addCase(updateChat.fulfilled, (state, action) => {
      const { id } = action.payload;
      const index = state.chatRoomList.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.chatRoomList[index] = { ...state.chatRoomList[index], ...action.payload };
      }
    });
    builder.addCase(getChats.fulfilled, (state, action) => {
      state.chatRoomList = action.payload;
    });
    builder.addCase(getChatMsgs.fulfilled, (state, action) => {
      if (action.payload) {
        state.currentChatList = action.payload.map((item) => {
          item.once = false;
          return item;
        });
      }
    });
  },
});

// Action creators are generated for each case reducer function
export const { setCurrentTopic, setCurrentChatList, setChat, updateChatMsg,deleteChatMsg, setCurrentKnowledgeTopic } = chatSlice.actions;

export default chatSlice.reducer;

export const selectCurrentTopic = (state: RootState) => state.chat.currentTopic;
export const selectCurrentChatList = (state: RootState) => state.chat.currentChatList;
export const selectChatRoomList = (state: RootState) => state.chat.chatRoomList;
export const selectKnowledgeBaseTopicList = (state: RootState) => state.chat.knowledgeBaseTopicList;
export const selectCurrentKnowledgeTopic = (state: RootState) => state.chat.currentKnowledgeTopic;